// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4090c258","261":"8842e960","325":"95274453","361":"61741cc3","453":"3a6b8a8b","519":"345f0c88","625":"9c78804c","654":"ec8a103c","688":"4c66f49c","840":"9b8f3e2e","859":"fa171327","870":"44079bc7","932":"a86ed315","939":"c5c92d77"}[chunkId] + ".chunk.js";
};